var map = {
	"./ad.svg": 3,
	"./ae.svg": 4,
	"./af.svg": 5,
	"./ag.svg": 6,
	"./ai.svg": 7,
	"./al.svg": 8,
	"./am.svg": 9,
	"./ao.svg": 10,
	"./ar.svg": 11,
	"./as.svg": 12,
	"./at.svg": 13,
	"./au.svg": 14,
	"./aw.svg": 15,
	"./az.svg": 16,
	"./ba.svg": 17,
	"./bb.svg": 18,
	"./bd.svg": 19,
	"./be.svg": 20,
	"./bf.svg": 21,
	"./bg.svg": 22,
	"./bh.svg": 23,
	"./bi.svg": 24,
	"./bj.svg": 25,
	"./bm.svg": 26,
	"./bo.svg": 27,
	"./br.svg": 28,
	"./bs.svg": 29,
	"./bt.svg": 30,
	"./bw.svg": 31,
	"./by.svg": 32,
	"./bz.svg": 33,
	"./ca.svg": 34,
	"./cd.svg": 35,
	"./cf.svg": 36,
	"./cg.svg": 37,
	"./ch.svg": 38,
	"./ci.svg": 39,
	"./ck.svg": 40,
	"./cl.svg": 41,
	"./cm.svg": 42,
	"./cn.svg": 43,
	"./co.svg": 44,
	"./cr.svg": 45,
	"./cu.svg": 46,
	"./cv.svg": 47,
	"./cw.svg": 48,
	"./cy.svg": 49,
	"./cz.svg": 50,
	"./de.svg": 51,
	"./dj.svg": 52,
	"./dk.svg": 53,
	"./dm.svg": 54,
	"./do.svg": 55,
	"./dz.svg": 56,
	"./ec.svg": 57,
	"./ee.svg": 58,
	"./eg.svg": 59,
	"./er.svg": 60,
	"./es.svg": 61,
	"./et.svg": 62,
	"./fi.svg": 63,
	"./fj.svg": 64,
	"./fk.svg": 65,
	"./fm.svg": 66,
	"./fo.svg": 67,
	"./fr.svg": 68,
	"./ga.svg": 69,
	"./gb.svg": 70,
	"./gd.svg": 71,
	"./ge.svg": 72,
	"./gg.svg": 73,
	"./gh.svg": 74,
	"./gi.svg": 75,
	"./gl.svg": 76,
	"./gm.svg": 77,
	"./gn.svg": 78,
	"./gq.svg": 79,
	"./gr.svg": 80,
	"./gt.svg": 81,
	"./gu.svg": 82,
	"./gw.svg": 83,
	"./hk.svg": 84,
	"./hn.svg": 85,
	"./hr.svg": 86,
	"./ht.svg": 87,
	"./hu.svg": 88,
	"./id.svg": 89,
	"./ie.svg": 90,
	"./il.svg": 91,
	"./im.svg": 92,
	"./in.svg": 93,
	"./io.svg": 94,
	"./iq.svg": 95,
	"./ir.svg": 96,
	"./is.svg": 97,
	"./it.svg": 98,
	"./je.svg": 99,
	"./jm.svg": 100,
	"./jo.svg": 101,
	"./jp.svg": 102,
	"./ke.svg": 103,
	"./kg.svg": 104,
	"./kh.svg": 105,
	"./ki.svg": 106,
	"./km.svg": 107,
	"./kn.svg": 108,
	"./kp.svg": 109,
	"./kr.svg": 110,
	"./kw.svg": 111,
	"./ky.svg": 112,
	"./kz.svg": 113,
	"./la.svg": 114,
	"./lb.svg": 115,
	"./li.svg": 116,
	"./lk.svg": 117,
	"./lr.svg": 118,
	"./ls.svg": 119,
	"./lt.svg": 120,
	"./lu.svg": 121,
	"./lv.svg": 122,
	"./ly.svg": 123,
	"./ma.svg": 124,
	"./mc.svg": 125,
	"./md.svg": 126,
	"./me.svg": 127,
	"./mg.svg": 128,
	"./mh.svg": 129,
	"./mk.svg": 130,
	"./ml.svg": 131,
	"./mm.svg": 132,
	"./mn.svg": 133,
	"./mo.svg": 134,
	"./mp.svg": 135,
	"./mq.svg": 136,
	"./mr.svg": 137,
	"./ms.svg": 138,
	"./mt.svg": 139,
	"./mu.svg": 140,
	"./mv.svg": 141,
	"./mw.svg": 142,
	"./mx.svg": 143,
	"./my.svg": 144,
	"./mz.svg": 145,
	"./na.svg": 146,
	"./nato.svg": 147,
	"./ne.svg": 148,
	"./nf.svg": 149,
	"./ng.svg": 150,
	"./ni.svg": 151,
	"./nl.svg": 152,
	"./no.svg": 153,
	"./np.svg": 154,
	"./nr.svg": 155,
	"./nu.svg": 156,
	"./nz.svg": 157,
	"./om.svg": 158,
	"./pa.svg": 159,
	"./pe.svg": 160,
	"./pf.svg": 161,
	"./pg.svg": 162,
	"./ph.svg": 163,
	"./pk.svg": 164,
	"./pl.svg": 165,
	"./pn.svg": 166,
	"./pr.svg": 167,
	"./ps.svg": 168,
	"./pt.svg": 169,
	"./pw.svg": 170,
	"./py.svg": 171,
	"./qa.svg": 172,
	"./ro.svg": 173,
	"./rs.svg": 174,
	"./ru.svg": 175,
	"./rw.svg": 176,
	"./sa.svg": 177,
	"./sb.svg": 178,
	"./sc.svg": 179,
	"./sd.svg": 180,
	"./se.svg": 181,
	"./sg.svg": 182,
	"./si.svg": 183,
	"./sk.svg": 184,
	"./sl.svg": 185,
	"./sm.svg": 186,
	"./sn.svg": 187,
	"./so.svg": 188,
	"./sr.svg": 189,
	"./ss.svg": 190,
	"./st.svg": 191,
	"./sv.svg": 192,
	"./sx.svg": 193,
	"./sy.svg": 194,
	"./sz.svg": 195,
	"./tc.svg": 196,
	"./td.svg": 197,
	"./tg.svg": 198,
	"./th.svg": 199,
	"./tibet.svg": 200,
	"./tj.svg": 201,
	"./tk.svg": 202,
	"./tm.svg": 203,
	"./tn.svg": 204,
	"./to.svg": 205,
	"./tr.svg": 206,
	"./tt.svg": 207,
	"./tv.svg": 208,
	"./tw.svg": 209,
	"./tz.svg": 210,
	"./ua.svg": 211,
	"./ug.svg": 212,
	"./us.svg": 213,
	"./uy.svg": 214,
	"./uz.svg": 215,
	"./ve.svg": 216,
	"./vi.svg": 217,
	"./vn.svg": 218,
	"./vu.svg": 219,
	"./ws.svg": 220,
	"./ye.svg": 221,
	"./za.svg": 222,
	"./zm.svg": 223,
	"./zw.svg": 224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;